import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { tokenStorage } from "@/lib/tokenStorage";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = tokenStorage.get("uc_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      tokenStorage.remove("uc_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data?.two_factor_required) {
      // Do NOT set token — caller must complete 2FA.
      return { two_factor_required: true, email: r.data.email };
    }
    tokenStorage.set("uc_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const loginTwoFactor = async (email, code) => {
    const r = await api.post("/auth/login/2fa", { email, code });
    tokenStorage.set("uc_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch { return null; }
  };

  const logout = () => {
    tokenStorage.remove("uc_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginTwoFactor, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
